export default __webpack_public_path__ + "static/media/pkg2.0dad9749.png";